import { Card } from '@ps/sports-ui-component-library';
import { FeatureFlag } from '@ps/web-core-enums';
import type { EventId } from '@ps/web-sports-api-types';
import React from 'react';
import type { Market as MarketType } from 'widgets/sports-competition-outrights-widget/types';

import useFeature from '@swf/core/hooks/useFeature';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { EachWayPlaceTerms, ExpandablePanel, Icon } from '@swf/sports/components';
import { isOddsBoostMarket } from '@swf/sports/utils/isOddsBoostMarket';

import { Default } from '../Default/Default';

import { TXTWCL_odds_boost } from './Market.messages.json';
import styles from './Market.scss';
import Title from './components/Title/Title';

export interface Props {
  openInitially: boolean;
  market: MarketType;
  eventId: EventId;
  eventStartTime: string;
}

const Market: React.FC<Props> = ({ openInitially, market, eventId, eventStartTime }) => {
  const { label, placeTerms, marketType } = market;
  const { formatMessage } = useRegulatoryIntl();
  const isPssOddsBoostMarketTypeCodesEnabled = useFeature(
    FeatureFlag.ISPReleasePssOddsBoostMarketTypeCodes
  );

  const showOddsBoost = isOddsBoostMarket(isPssOddsBoostMarketTypeCodesEnabled, marketType);
  const title = (
    <Title>
      {showOddsBoost ? (
        <Icon name="oddsboost-full" label={formatMessage(TXTWCL_odds_boost)} size="lg" />
      ) : (
        label
      )}
    </Title>
  );

  return (
    <Card className={styles.card}>
      <ExpandablePanel title={title} openInitially={openInitially}>
        <EachWayPlaceTerms placeTerms={placeTerms} className={styles.eachWay} />
        <Default
          {...market}
          eventId={eventId}
          eventStartTime={eventStartTime}
          showPreviousPrice={showOddsBoost}
        />
      </ExpandablePanel>
    </Card>
  );
};

export default Market;
